import ReportTracingAbilityDetail from '@/models/ReportTracingAbilityDetail/ReportTracingAbilityDetail';

export default class ReportTracingAbilityDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterControlCardId = '';
		this.tempId = '';
		this.materialSource = '';
		this.partNumber = '';
		this.controlCardDestination = '';
		this.lotNo = '';
		this.wopNumber = '';
		this.productionDate = '';
		this.finishProductionDate = '';
		this.machine = '';
		this.operatorUser = '';
		this.shift = '';
		this.qtyBefore = '';
		this.qtyAfter = '';
		this.qtyTaken = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterControlCardId : '0',
			tempId : '0',
			materialSource : '0',
			partNumber : '0',
			controlCardDestination : '0',
			lotNo : '0',
			wopNumber : '0',
			productionDate : '0',
			finishProductionDate : '0',
			machine : '0',
			operatorUser : '0',
			shift : '0',
			qtyBefore : '0',
			qtyAfter : '0',
			qtyTaken : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}